// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3SEi2","col":"styles_col__1ac3S"};